// Translator notes: HV → FI/EN, a sentence whose only verb is a bare infinitive that is not a wish,
// permission or "let us" (engine rules/no-finite-verb.ts, passes/no-finite-verb.ts; fix batch
// 2026-10-07; those readings: rules/infinitive-commands.ts, notes in infinitive-commands.notes.ts).
// Each id is an engine note (`notes.add(text, id, args)`); collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  noFiniteVerb: {
    args: ['verb'],
    fi: (a: string[]) =>
      `Lauseen ainoa verbi on infinitiivi ”${a[0]}”, eikä siinä ole persoonamuotoista verbiä. Valyriassa tällainen lause on usein toive tai lupa (”Aōt vaodekuragon” = saat lähestyä), mutta tätä lausetta kääntäjä ei tunnista kummaksikaan, joten käännös on arvaus.`,
    en: (a) =>
      `The sentence’s only verb is the infinitive “${a[0]}”, with no finite verb. In High Valyrian such a sentence is often a wish or permission (“Aōt vaodekuragon” = you may approach), but the translator does not recognise this one as either, so the translation is a guess.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
